import { get, find, values, orderBy } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getReservationArchived = get('reservation.archived');

export const getAll = createSelector(getReservationArchived, get('all'));

export const getAllValues = createSelector(getAll, values);

export const getItemForBarcode = createSelector(
  (_, code) => ({ code }),
  getAllValues,
  find
);

export const getOrderedArchived = createSelector(
  getAllValues,
  orderBy('id', 'desc')
);

export const getOrder = createSelector(getReservationArchived, get('order'));

export const getIsFetching = createSelector(
  getReservationArchived,
  get('fetching')
);
export const getIsFetched = createSelector(
  getReservationArchived,
  get('fetched')
);

export const getFetchingError = createSelector(
  getReservationArchived,
  get('fetchingError')
);

export const getIsSaving = createSelector(
  getReservationArchived,
  get('saving')
);

export const getIsSaved = createSelector(getReservationArchived, get('saved'));
